import React, { FC } from "react";

import { ConfirmationModal } from "@components/common";
import { useMultistepFormStore } from "@components/common/MultistepForm";
import { useDeleteFormSectionConfig } from "@api";
import { useUserStore } from "@store/user";

const DeleteSectionConfirmation: FC = () => {
  const {
    activeSection,
    previousSection,
    deleteSectionOpen,
    setDeleteSectionOpen,
    formSettings: {
      formBasics: { id },
    },
  } = useMultistepFormStore();
  const { user } = useUserStore();
  const { deleteFormSectionConfig, deleteFormSectionConfigEnabled } =
    useDeleteFormSectionConfig(user, id);
  const handleDeleteSection = (): void => {
    if (activeSection) {
      deleteFormSectionConfig(activeSection.id);
    }
    setDeleteSectionOpen(false);
    previousSection();
  };

  return (
    deleteFormSectionConfigEnabled && (
      <ConfirmationModal
        open={deleteSectionOpen}
        onClose={() => setDeleteSectionOpen(false)}
        onConfirm={handleDeleteSection}
        title="Do you really wnat to remove this section?"
      />
    )
  );
};

export default DeleteSectionConfirmation;
